import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

const DropBox = styled(Box)(({ theme }) => ({
  "&.MuiBox-root": {
    backgroundColor: theme.palette.common.white,
    borderRadius: "12px",
    boxShadow: `${theme.palette.common.black}19 0px 8px 24px`,
    padding: "8px",
  },
  "&.MuiBox-root:hover, &.MuiBox-root.dragover": {
    opacity: 0.6,
  },
}));

export default DropBox;
